import PropTypes from 'prop-types';
import React from 'react';

import {CurrentUserContext} from './Router';

class LogoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    const {history} = this.props;

    return (
      <div>
        <p>
          Click below to log out.
        </p>

        <CurrentUserContext.Consumer>
          {({logoutUser}) => (
            <button
              className="btn btn-primary"
              onClick={async () => {
                await logoutUser();
                history.push('/')
              }}
            >
              Log Out
            </button>
          )}
        </CurrentUserContext.Consumer>
      </div>

    )
  }
}

LogoutPage.propTypes = {
  history: PropTypes.object.isRequired,
}

export {LogoutPage};



// WEBPACK FOOTER //
// ./src/LogoutPage.js